module.exports = __webpack_public_path__ + "static/img/logo_.a31654e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_.png
// module id = Rj5/
// module chunks = 22